import React from "react";
import axios from "axios";
import "./style.css";
import HeaderEn from "../../../header-en";

import ArashFendereskiImage from "../../../../../assets/CEO-Profile.png";
import FooterEn from "../../../footer-en";

class ArashFendereskiEn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendMessage: "Hello,I'mInArashFendereskiPageEn",
    };
  }

  componentDidMount = () => {
    this.handleRedirect();
  };

  //put this function in the related component in componentDidMount
  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  render() {
    return (
      <div>
        <HeaderEn />
        <div className="about-profile-body d-ltr">
          <div className="about-profile-container">
            <div className="about-profile-body-left">
              <h1>Arash Fendereski</h1>
              <h3>Chief Technology Officer</h3>
              <p>
                I love working with data and algorithms and I have 6 years of
                experience in designing AI solutions.
              </p>
            </div>
            <div className="about-profile-body-right">
              <div className="about-profile-image-container">
                <img src={ArashFendereskiImage}></img>
              </div>
            </div>
          </div>
        </div>
        <FooterEn />
      </div>
    );
  }
}

export default ArashFendereskiEn;
